export const iconFontAwesomeUsersPeoplePersonBreastfeeding = (
	<i className="fa-solid fa-person-breastfeeding"></i>
);
